<script lang="ts">
  // Dense list of races (one row each: title · leader & counted share · status), for secondary races such as the
  // down-ballot statewide offices. Two columns on wide screens.
  import type { RaceSummary } from '../../types';
  import { app } from '../../lib/app.svelte';
  import { fmtPct } from '../../lib/format';
  import { cardName, colorVar, hasVotes, leader, winMarks } from '../../lib/race';
  import WinMark from '../atoms/WinMark.svelte';
  import StatusPill from '../atoms/StatusPill.svelte';
  let { races }: { races: RaceSummary[] } = $props();
</script>

<ul class="rows">
  {#each races as r (r.race_id)}
    <!-- the row names whoever the status pill is about: the AP's winner, our projected/decided winner, else the
         leader in votes counted (so "Projected" never sits next to the candidate who is behind in the projection) -->
    {@const marks = winMarks(r)}
    {@const won = marks.size > 0 && r.vote_for === 1}
    {@const l = (won ? leader(r) : null) ?? r.choices[0]}
    {@const mk = l ? marks.get(l.choice_id) : undefined}
    <li>
      <a href={app.href(`#/race/${encodeURIComponent(r.race_id)}`)}>
        <span class="t">{r.title}</span>
        <span class="who">
          {#if l && hasVotes(r)}<i style="background:{colorVar(l)}"></i>{cardName(l, r.kind)} <b class="num">{fmtPct(l.pct)}</b>{#if mk}<WinMark kind={mk} compact />{/if}{:else}<span class="muted">No votes yet</span>{/if}
        </span>
        <span class="st"><StatusPill race={r} /></span>
      </a>
    </li>
  {/each}
</ul>

<style>
  .rows { list-style: none; margin: 0; padding: 0; display: grid; grid-template-columns: 1fr; column-gap: 24px; background: var(--card); border: 1px solid var(--line); border-radius: var(--r-card); box-shadow: var(--shadow); padding: 4px 18px; }
  @media (min-width: 900px) { .rows { grid-template-columns: 1fr 1fr; } }
  li { border-top: 1px solid var(--line); }
  li:first-child { border-top: 0; }
  @media (min-width: 900px) { li:nth-child(2) { border-top: 0; } }
  a { display: grid; grid-template-columns: minmax(0, 1fr) auto; gap: 2px 10px; padding: 11px 0; color: inherit; text-decoration: none; }
  a:hover .t { text-decoration: underline; }
  .t { font-weight: 600; font-size: 0.95rem; }
  .who { grid-column: 1; display: flex; align-items: center; gap: 6px; font-size: 0.85rem; color: var(--ink-2); min-width: 0; }
  .who i { width: 9px; height: 9px; border-radius: 3px; flex: none; }
  .st { grid-column: 2; grid-row: 1 / span 2; align-self: center; }
</style>
